import { render, staticRenderFns } from "./AddStorageChange.vue?vue&type=template&id=074f0921&scoped=true&"
import script from "./AddStorageChange.vue?vue&type=script&lang=js&"
export * from "./AddStorageChange.vue?vue&type=script&lang=js&"
import style0 from "./AddStorageChange.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddStorageChange.vue?vue&type=style&index=1&id=074f0921&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f0921",
  null
  
)

export default component.exports